<template>
  <div class="about">
    <h1>This the home page</h1>
    <br />
    <b-button variant="primary" @click="healthCheck">Auth Healthcheck</b-button>
    <br />
    <br />
    <b-button variant="primary" @click="clearAuthHeader">Clear Auth Header Axios</b-button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  methods: {
    healthCheck(e) {
      e.preventDefault();
      axios
        .get(process.env.VUE_APP_API_SERVER.concat("/v1/health/auth"), {})
        .then(response => console.log(response.data))
        .catch(error => console.log(error))
        .finally(() => (this.loading = false));
    },
    clearAuthHeader(e) {
      e.preventDefault();
      axios.defaults.headers.common["Authorization"] = undefined;
    },
    mounted() {}
  }
};
</script>
